class BrowserStorage {
  constructor(storage, requestFrom) {
    this.storage = storage;
    this.requestFrom = requestFrom;
  }
  getItem(key) {
    return this.storage.getItem(key);
  }
  setItem(key, value) {
    this.storage.setItem(key, value);
  }
  removeItem(key) {
    this.storage.removeItem(key);
    this.storage.removeItem(`PennyInitialMessageSubmitted-${this.requestFrom}`);
  }
  updateUserMessageCount(count) {
    this.storage.setItem('PennyUserMessageCount', count);
  }
  getUserMessageCount() {
    const data = this.storage.getItem('PennyUserMessageCount');
    return parseInt(data, 10);
  }
  isInitialMessageSubmitted() {
    if (!this.storage) {
      return true;
    }
    return this.storage.getItem(`PennyInitialMessageSubmitted-${this.requestFrom}`) === 'true';
  }
  setInitialMessageSubmitted() {
    if (this.storage) {
      this.storage.setItem(`PennyInitialMessageSubmitted-${this.requestFrom}`, 'true');
    }
  }
}
/**
 * browserStorage: use to access browser storage
 * @public
 */
export let browserStorage;
/**
 * initBrowserStorage: use to initialize browser storage
 * @public
 */
export const initBrowserStorage = requestFrom => {
  if (typeof window === 'undefined' || !!browserStorage) {
    return;
  }
  browserStorage = new BrowserStorage(window.sessionStorage, requestFrom);
  return browserStorage;
};